// import { useState } from "react";
// import Login from "./loginAdmin.css"
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import CryptoJS from "crypto-js";
// // import { secretKey } from "./config";
// import{ secretKey } from "../../config";
// import { BsArrowRight } from "react-icons/bs";
// import { FiEye, FiEyeOff } from "react-icons/fi";
// // import history from './history';
// function LoginAdmin() {
//   const [username, setUserName] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const imageUrl = "./assets/images/login-bg.jpg";
//   // Extract Role from JWT Token
//   const getRoleFromToken = () => {
//     const token = localStorage.getItem("token");  
//     if (!token) return null;
  
//     try {
//       // Decode JWT
//       const base64Url = token.split(".")[1]; // Get payload part
//       const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
//       const decodedData = JSON.parse(atob(base64)); // Decode base64
  
//       return decodedData.role; // Assuming the role is stored as "role"
//     } catch (error) {
//       console.error("Error decoding token:", error);
//       return null;
//     }
//   };
//   // const userRole = getRoleFromToken();
//   // console.log("User Role:", userRole);

//   // Function to encrypt role
//   const encryptData = (data) => {
//     return CryptoJS.AES.encrypt(data, secretKey).toString();
//   };

//   // Function to decrypt role
// const decryptData = (encryptedData) => {
//   const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//   return bytes.toString(CryptoJS.enc.Utf8);
// };

//   // Get Role from Token and Store Encrypted in Local Storage
//   const storeUserRole = () => {
//     const role = getRoleFromToken(); // Extract role from token
//     if (role) {
//       const encryptedRole = encryptData(role);
//       localStorage.setItem("userRole", encryptedRole);
//     }
//   };
//   // Retrieve Role Securely from Local Storage
//   const getUserRole = () => {
//     const encryptedRole = localStorage.getItem("userRole");
//     return encryptedRole ? decryptData(encryptedRole) : null;
//   };
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError("");
//       // Validation checks
//       if (!username.trim()) {
//         setError("Username is required.");
//         return;
//       }
//       if (!password.trim()) {
//         setError("Password is required.");
//         return;
//       }  

    // try {
    //   const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/login`, 
    //   {  
    //     username,
    //     password,
    //     role: "admin",
    //   },
    //   {
    //     headers:{
    //       "Accept" : "application/json",
    //       "Content-Type": "application/json",
    //       // "Access-Control-Allow-Origin" : '*'
    //     },
    //   }     
    //  );

    //   // console.log("Login Success:", response.data);
    //   localStorage.setItem("token", response.data.token); // Store token if needed
    //   localStorage.setItem("username", username);    
    //   storeUserRole();

    //   navigate("/admin-reporting"); 
    // } catch (err) {
    //   setError(err.response?.data?.message || "Login failed. Please try again.");
    // }
//   };
//   return (
//     <>
//       {/* <Container fluid className="px-0"> */}
//       {/* <Container fluid>
//       <Row>
//         <Col>1 of 1</Col>
//       </Row>
//     </Container>   */}
//       <div className="row g-0 min-vh-100">
//         {/* <!-- Welcome Text
//       ========================= --> */}
//         <div className="col-md-6">
//           <div className="hero-wrap d-flex align-items-center h-100">
//             <div className="hero-mask opacity-8 bg-primary"></div>
//             <div className="hero-bg hero-bg-scroll"></div>
//             <div className="hero-content w-100 min-vh-100 d-flex flex-column">
//               <div className="row g-0">
//                 <div className="col-11 col-sm-10 col-lg-9 mx-auto">
//                   <div className="logo mt-5 mb-5 mb-md-0">
//                       <h1 className="font-weight-bold text-light">Adchronix</h1>
//                   </div>
//                 </div>
//               </div>
//               <div className="row g-0 my-auto">
//                 <div className="col-11 col-sm-10 col-lg-9 mx-auto">
//                   {/* <h1 className="text-11 text-white mb-1"> </h1> */}
//                   <p className="text-white lh-base mb-5" style={{fontSize:"25px"}}>
//                   Unlock the full revenue potential of your website with <span>AdChronix</span>.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* <!-- Welcome Text End --> 
      
//       <!-- Login Form
//       ========================= --> */}
//         <div className="col-md-6 d-flex">
//           <div className="container my-auto py-5">
//             <div className="row g-0">
//               <div className="col-11 col-sm-10 col-lg-9 col-xl-8 mx-auto">
//                 <h3 className="fw-600 mb-4">Log In</h3>
//                 {error && <p className="text-danger">{error}</p>}
//                 <form onSubmit={handleLogin} id="loginForm" method="post">
//                   <div className="mb-3">
//                     <label htmlFor="username" className="form-label">
//                       User name
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="username"
//                       required=""
//                       placeholder="Enter username"
//                       value={username}
//                       onChange={(e) => setUserName(e.target.value)}
//                     />
//                   </div>
//                   {/* <div className="mb-3">
//                     <label htmlFor="loginPassword" className="form-label">
//                       Password
//                     </label>
//                     <input
//                       type="password"
//                       className="form-control"
//                       id="loginPassword"
//                       required=""
//                       placeholder="Enter Password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                     />
//                   </div> */}
//                   <div className="mb-3">
//                     <label htmlFor="loginPassword" className="form-label">
//                       Password
//                     </label>

//                     <div className="position-relative">
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         className="form-control inputBG pe-5"
//                         id="loginPassword"
//                         required=""
//                         placeholder="Enter Password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                       />

//                       <button
//                         type="button"
//                         onClick={() => setShowPassword(!showPassword)}
//                         className="position-absolute top-50 end-0 translate-middle-y"
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           padding: "8px 12px",
//                           cursor: "pointer",
//                         }}
//                         aria-label={showPassword ? "Hide password" : "Show password"}
//                       >
//                         {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
//                       </button>
//                     </div>
//                   </div>
//                     {/* <div className="col">
//                       <p>publisher</p>
//                     </div> */}
//                     {/* <div className="col text-end">
//                       <a href="forgot-password.html">Forgot Password ?</a>
//                     </div> */}
//                   <div className="d-grid my-4">
//                     <button className="loginBtn bg-primary text-light text-center" type="submit">
//                       Login
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* <!-- Login Form End -->  */}
//       </div>
//       {/* </Container> */}
//     </>
//   );
// }

// export default LoginAdmin;


// export default LoginPage;

import { useState } from "react";
import "./loginAdmin.css";
import axios from "axios";
import { secretKey } from "../../config";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { FiEye, FiEyeOff, FiUser, FiLock } from "react-icons/fi";

function LoginAdmin() {

  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const getRoleFromToken = () => {
    const token = localStorage.getItem("token");

    if (!token) return null;

    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url
        .replace(/-/g, "+")
        .replace(/_/g, "/");

      const decodedData = JSON.parse(atob(base64));

      return decodedData.role;

    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };


  const storeAccountId = () => {

    const token = localStorage.getItem("token");

    if (!token) return;

    try {

      const base64Url = token.split(".")[1];

      const base64 = base64Url
        .replace(/-/g, "+")
        .replace(/_/g, "/");

      const decodedData = JSON.parse(atob(base64));

      if (decodedData.account_id) {
        localStorage.setItem(
          "account_id",
          decodedData.account_id
        );
      }

    } catch (error) {
      console.error("Error decoding token:", error);
    }
  };


  const encryptData = (data) => {
    return CryptoJS.AES
      .encrypt(data, secretKey)
      .toString();
  };


  const decryptData = (encryptedData) => {

    const bytes = CryptoJS.AES.decrypt(
      encryptedData,
      secretKey
    );

    return bytes.toString(
      CryptoJS.enc.Utf8
    );
  };


  const storeUserRole = () => {

    const role = getRoleFromToken();

    if (role) {

      const encryptedRole =
        encryptData(role);

      localStorage.setItem(
        "userRole",
        encryptedRole
      );
    }
  };


  const handleLogin = async (e) => {

    e.preventDefault();

    setError("");

    if (!username.trim()) {
      setError("Username is required.");
      return;
    }

    if (!password.trim()) {
      setError("Password is required.");
      return;
    }


try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/login`, 
      {  
        username,
        password,
        role: "admin",
      },
      {
        headers:{
          "Accept" : "application/json",
          "Content-Type": "application/json",
          // "Access-Control-Allow-Origin" : '*'
        },
      }     
     );

      // console.log("Login Success:", response.data);
      localStorage.setItem("token", response.data.token); // Store token if needed
      localStorage.setItem("username", username);    
      storeUserRole();

      navigate("/dashboard"); 
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Please try again.");
    }
  };


  return (

    <div className="login-page">

      {/* LEFT SIDE */}

      <section className="login-hero">

        <div className="login-hero-overlay"></div>

        <div className="login-hero-content">

          <div className="login-brand">
            <div className="login-brand-icon">
              Ad
            </div>

            <span>
              Adchronix
            </span>
          </div>


          <div className="login-hero-text">

            <span className="login-badge">
              AD MONETIZATION PLATFORM
            </span>

            <h1>
              Unlock the full revenue
              potential of your website.
            </h1>

            <p>
              Powerful AD Monetization solutions
              designed to help publishers
              maximize their digital revenue.
            </p>

          </div>


          <div className="login-hero-footer">
            © {new Date().getFullYear()} Adchronix
          </div>

        </div>

      </section>


      {/* RIGHT SIDE */}

      <section className="login-form-section">

        <div className="login-form-container">

          <div className="login-form-header">

            <div className="mobile-logo">
              <div className="login-brand-icon">
                Ad
              </div>

              <span>
                Adchronix
              </span>
            </div>

            <h2>
              Welcome back
            </h2>

            <p>
              Sign in to your account
            </p>

          </div>


          {error && (
            <div className="login-error">
              {error}
            </div>
          )}


          <form
            onSubmit={handleLogin}
            className="login-form"
          >

            {/* USERNAME */}

            <div className="login-field">

              <label htmlFor="username">
                Username
              </label>

              <div className="login-input-wrapper">

                <FiUser className="login-input-icon" />

                <input
                  type="text"
                  id="username"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) =>
                    setUserName(e.target.value)
                  }
                />

              </div>

            </div>


            {/* PASSWORD */}

            <div className="login-field">

              <div className="login-label-row">

                <label htmlFor="loginPassword">
                  Password
                </label>

              </div>


              <div className="login-input-wrapper">

                <FiLock className="login-input-icon" />

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  id="loginPassword"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) =>
                    setPassword(e.target.value)
                  }
                />


                <button
                  type="button"
                  className="password-toggle"
                  onClick={() =>
                    setShowPassword(!showPassword)
                  }
                  aria-label={
                    showPassword
                      ? "Hide password"
                      : "Show password"
                  }
                >
                  {showPassword
                    ? <FiEyeOff />
                    : <FiEye />
                  }
                </button>

              </div>

            </div>


            {/* LOGIN BUTTON */}

            <button
              type="submit"
              className="login-submit"
            >

              <span>
                Sign in
              </span>

              <BsArrowRight />

            </button>

          </form>


          <div className="login-security">
            Secure access
          </div>

        </div>

      </section>

    </div>
  );
}

export default LoginAdmin;
